export default __webpack_public_path__ + "static/media/gb.92127ed7.svg";